import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Paper,
    Typography,
} from "@material-ui/core"
import { Block } from "@material-ui/icons"
import React, { useState } from "react"
import { useHistory } from "react-router-dom"
import { useSnackbar } from "../../../utils/notificacoes"
import { useEdicaoClienteContext } from "../context/useEdicaoClienteContext"
import { useCardStyles } from "./estilosCards"

type Confirmacao = "excluir" | "bloquear" | "desbloquear" | null

export function BloqueioCliente() {
    const classes = useCardStyles()
    const history = useHistory()
    const { dados, alterarBloqueio, excluirCliente } = useEdicaoClienteContext()
    const { enqueueSnackbar } = useSnackbar()

    const alertStart = (msg: string, tipo: "success" | "error" | "info") => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const [confirmacao, setConfirmacao] = useState<Confirmacao>(null)

    const handleConfirmar = async () => {
        const acao = confirmacao
        setConfirmacao(null)
        if (!acao) return

        try {
            if (acao === "excluir") {
                const mensagem = await excluirCliente()
                alertStart(mensagem, "success")
                history.push("/clientes")
                return
            }
            alertStart(await alterarBloqueio(acao === "bloquear"), "success")
        } catch (error) {
            alertStart((error as Error).message || "Não foi possível concluir a operação", "error")
        }
    }

    const textoConfirmacao =
        confirmacao === "excluir"
            ? "Tem certeza que deseja excluir este cliente? O cadastro será desativado e os dados pessoais removidos."
            : confirmacao === "bloquear"
            ? "Tem certeza que deseja bloquear este cliente?"
            : "Tem certeza que deseja desbloquear este cliente?"

    return (
        <Paper className={classes.configCard}>
            <Box className={classes.cardHeader}>
                <Block className={classes.iconHeader} />
                <Typography variant="h6" className={classes.cardHeaderTitle}>
                    Bloqueio e exclusão do usuário
                </Typography>
            </Box>

            <Box className={classes.cardContent} display="flex" flexWrap="wrap" gridGap={12}>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => setConfirmacao("excluir")}
                >
                    Excluir Usuário
                </Button>

                {dados.ativo ? (
                    <Button variant="outlined" onClick={() => setConfirmacao("bloquear")}>
                        Bloquear Usuário
                    </Button>
                ) : (
                    <Button variant="outlined" onClick={() => setConfirmacao("desbloquear")}>
                        Desbloquear Usuário
                    </Button>
                )}
            </Box>

            <Dialog open={confirmacao !== null} onClose={() => setConfirmacao(null)}>
                <DialogTitle>Confirmar operação</DialogTitle>
                <DialogContent>
                    <Typography>{textoConfirmacao}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmacao(null)}>Cancelar</Button>
                    <Button color="secondary" variant="contained" onClick={handleConfirmar}>
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>
        </Paper>
    )
}
